import { createFileRoute, redirect } from '@tanstack/react-router';
import { MUTUAL_FUNDS_DIVIDEND_ACCRUAL_BASE_PATH } from '../../../../../../../../features/mutual-funds/dividend-accrual/dividend-accrual-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/')({
  beforeLoad: () => {
    throw redirect({ to: MUTUAL_FUNDS_DIVIDEND_ACCRUAL_BASE_PATH });
  },
  preload: false,
});
